import { ILanguage } from "./models";

export const SupportedLanguages: ILanguage[] = [
	{ name: 'English', abrv: 'en', iso: 'en-US' }
	// TODO: add more languages here
]